import { OrderStatus } from 'types/Orders.types';

// The statuses a supplier sets by hand. SENDING and UNKNOWN are never offered:
// only Logyx core moves an order into or out of them (it answers 422 and 409).
export const statusOptions = [
  {
    id: 1,
    value: OrderStatus.SUCCESSFUL,
    label: 'Successful',
  },
  {
    id: 2,
    value: OrderStatus.PENDING,
    label: 'Pending',
  },
  {
    id: 3,
    value: OrderStatus.FAILED,
    label: 'Failed',
  },
];
